// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","header-scrolled":"header-scrolled__vT1LF","logo":"logo__jPF5-"};